import { Alert, AlertIcon, Box, CloseButton, Flex, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { MAINTENANCE_INFO, MONTH_LIST } from '../constants'

const MaintenanceBanner = () => {
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    const currentTime = Math.floor(Date.now() / 1000)
    if (
      currentTime >= MAINTENANCE_INFO.notificationStartTime &&
      currentTime <= MAINTENANCE_INFO.notificationEndTime
    ) {
      setShowBanner(true)
    }
  }, [])

  if (!showBanner) return null

  const formatMaintenanceTime = () => {
    const startDate = new Date(MAINTENANCE_INFO.startTime * 1000)
    const endDate = new Date(MAINTENANCE_INFO.endTime * 1000)

    const startDay = startDate.getDate()
    const startMonth = MONTH_LIST[startDate.getMonth()]
    const startYear = startDate.getFullYear()

    const startHours = startDate.getHours()
    const startMinutes = startDate.getMinutes()
    const startAmPm = startHours >= 12 ? 'PM' : 'AM'
    const formattedStartHours = startHours % 12 || 12
    const formattedStartMinutes = startMinutes.toString().padStart(2, '0')

    const endHours = endDate.getHours()
    const endMinutes = endDate.getMinutes()
    const endAmPm = endHours >= 12 ? 'PM' : 'AM'
    const formattedEndHours = endHours % 12 || 12
    const formattedEndMinutes = endMinutes.toString().padStart(2, '0')

    return `Scheduled maintenance on ${startDay} ${startMonth} ${startYear} from ${formattedStartHours}:${formattedStartMinutes} ${startAmPm} to ${formattedEndHours}:${formattedEndMinutes} ${endAmPm} AEST. Services will be unavailable during this time.`
  }

  return (
    <Box position="fixed" top="0" left="0" right="0" zIndex="banner">
      <Alert status="warning" variant="solid" position="relative">
        <Flex width="100%" justifyContent="center" alignItems="center">
          <AlertIcon />
          <Text textAlign="center">{formatMaintenanceTime()}</Text>
        </Flex>
        <CloseButton
          position="absolute"
          right="8px"
          top="50%"
          transform="translateY(-50%)"
          onClick={() => setShowBanner(false)}
        />
      </Alert>
    </Box>
  )
}

export default MaintenanceBanner
